import React from 'react'

const Message = ({ message }) => (
  <div className='h-screen w-full flex items-center justify-center text-xl font-bold sm:bg-gray-100'>
    {message}
  </div>
)

export default Message
